// src/components/agents/AgentPropertiesSection.jsx

import Properties from "../../pages/properties/Properties";

import { useAuthStore } from "../../store/authStore";


export default function AgentPropertiesSection({
  agentId,
  setSelectedProperty,
}) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  return (
    <section className="properties-section">
      <div className="properties-header d-flex align-center justify-between">
        <h2 className="primary">Properties</h2>

        {isAdmin && (
          <button
          className="btn w-auto py-1 px-3 d-flex align-center text-sm fw-semibold bg-gradient-primary btn-hover-glow rounded-20"
          onClick={() => setSelectedProperty({})}
        >
          Add Property
        </button>
        )}
      </div>

      <Properties agentId={agentId} />
    </section>
  );
}